import React from 'react';


//Material-ui

class Comp extends React.Component {
	render() {
    let styleOuter = {
      position:'relative',
      display:'inline-block',
      margin:'3px',
      padding:'5px 10px',
      background:'#FFBC57',
      textAlign:'left',
      zIndex:'10',
      color:'#754600',
			borderRadius:'12px',
    }

		let styleArrow = {};
		if (this.props.arrow === 'top') {
			styleArrow = {
	      position: 'absolute',
	  		content: ' ',
	  		top: '-16px',
	  		left: '50%',
	  		marginLeft: '-8px',
	  		borderStyle: 'solid',
	  		borderWidth: '0px 8px 16px 8px',
	  		borderColor: 'transparent transparent #FFBC57 transparent',
	    }
		}

		return (
			<div style={styleOuter}>
        <div style={styleArrow} />
        {this.props.children}
			</div>
		)
	}
}

export default Comp;
